import { render, staticRenderFns } from "./DetailCampusDiplomasList.vue?vue&type=template&id=3efc194c"
import script from "./DetailCampusDiplomasList.vue?vue&type=script&lang=js"
export * from "./DetailCampusDiplomasList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Diplomes3Collone: require('/home/etienne/AM-frontend/components/Diplomes3Collone.vue').default,Diplomes: require('/home/etienne/AM-frontend/components/Diplomes.vue').default})
